import { Link as RouterLink } from 'react-router-dom'
import { Link, StatusWidget } from '@revolut-internal/ui-kit'
import { FC } from 'react'

import { getRootRoute } from 'lib/router'

type Props = {
  title?: string
  description?: string
}

export const NotFoundWidget: FC<Props> = props => (
  <StatusWidget>
    <StatusWidget.Image
      image={{
        default: 'https://assets.revolut.com/assets/3d-images-v2/3D086.png',
        '2x': 'https://assets.revolut.com/assets/3d-images-v2/3D086@2x.png',
        '3x': 'https://assets.revolut.com/assets/3d-images-v2/3D086@3x.png',
      }}
    />
    <StatusWidget.Title>{props.title}</StatusWidget.Title>
    {props.description && (
      <StatusWidget.Description>{props.description}</StatusWidget.Description>
    )}
    <StatusWidget.Action>
      <Link use={RouterLink} to={getRootRoute()}>
        Home page
      </Link>
    </StatusWidget.Action>
  </StatusWidget>
)
